<template>
  <div class="card-item">
    <div class="title-box">
      <span class="title-text">品牌基本信息</span>
    </div>
    <div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>品牌名称
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              placeholder="请输入品牌名称"
              :maxLength="100"
              v-model="info.name"
              :disabled="isEdit || !isRevise"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>申报年份
          </div>
          <div class="pl16">
            <a-date-picker
              placeholder="请选择申报年份"
              v-model="info.applyYear"
              :disabled="isEdit"
              :open="yearShowOne"
              :locale="locale"
              :format="'YYYY'"
              mode="year"
              @openChange="openChangeOne"
              @panelChange="panelChangeOne"
              class="form-item-right"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>所属部门
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              placeholder="请输入所属部门"
              :maxLength="100"
              v-model="info.belongDepartment"
              :disabled="isEdit"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>建设日期
          </div>
          <div class="pl16">
            <a-date-picker
              placeholder="请选择建设日期"
              v-model="info.foundTime"
              :disabled="isEdit"
              :format="'YYYY-MM-DD'"
              :locale="locale"
              class="form-item-right"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>品牌层级
          </div>
          <div class="pl16">
            <a-radio-group
              v-model="info.brandClassify"
              :disabled="isEdit"
              @change="handleChangebrandClassify"
            >
              <a-radio value="校园文化品牌"> 校园文化品牌 </a-radio>
              <a-radio value="专业文化品牌"> 专业文化品牌 </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>品牌文化
          </div>
          <div class="pl16">
            <el-cascader
              ref="cascaderRef"
              :key="cascaderKey"
              :disabled="isEdit"
              :options="kcList"
              :props="cascaderProps"
              placeholder="请选择品牌文化"
              @change="onChange"
              v-model="info.brandLabels"
              style="width: 100%"
              filterable
              @keydown.native="handleEnterKey"
            ></el-cascader>
          </div>
        </div>
      </div>
      <div class="mt30" v-if="isShowZy">
        <div class="form-item" style="width: 100%">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span> 所属专业
          </div>
          <div
            class="pl16"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <a-select
              style="width: 32%"
              show-search
              v-model="info.basicMajorCategory"
              option-filter-prop="children"
              :filter-option="filterOption"
              :disabled="isEdit || isScore"
              @change="handleChange"
            >
              <a-select-option value="">请选择专业大类</a-select-option>
              <a-select-option
                v-for="item in zydlList"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select
              style="width: 32%"
              show-search
              v-model="info.basicMajorSubclass"
              option-filter-prop="children"
              :filter-option="filterOption"
              :disabled="isEdit || isScore"
              @change="handleChange1"
            >
              <a-select-option value="">请选择专业子类</a-select-option>
              <a-select-option
                v-for="item in zyzlList"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
            <a-select
              style="width: 32%"
              show-search
              v-model="info.basicMajor"
              option-filter-prop="children"
              :filter-option="filterOption"
              :disabled="isEdit || isScore"
            >
              <a-select-option value="">请选择专业</a-select-option>
              <a-select-option
                v-for="item in zyList"
                :value="item.id"
                :key="item.id"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item" style="width: 100%">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>品牌内涵
          </div>
          <div class="pl16">
            <a-select
              mode="tags"
              v-model="info.keyword"
              placeholder="请选择品牌内涵"
              @change="handleChangeKeyword"
              style="width: 100%"
              class="keywordSelect"
              :disabled="isEdit"
            >
              <a-select-option
                v-for="tag in ppnhList"
                :key="tag.value"
                :value="tag.value"
              >
                {{ tag.title }}
              </a-select-option>
            </a-select>
            <span style="color: #999; line-height: 3"
              >如无选项，可根据实际情况自行凝练，要求精炼</span
            >
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item-upload" style="width: 100%">
          <div class="main-text-style">
            <span style="color: #f6350f">*</span>
            申报书上传
          </div>
          <div class="pl16">
            <a-upload
              :file-list="fileList"
              :disabled="isEdit"
              :remove="(file, fileList) => handleRemove(file, fileList)"
              :before-upload="(file, fileList) => beforeUpload(file, fileList)"
              accept=".pdf"
              :style="{ cursor: isEdit ? 'pointer' : '' }"
              @preview="handlePreview"
            >
              <a-button :disabled="isEdit || loading" :loading="loading">
                <a-icon type="upload" /> 上传附件
              </a-button>
              <span class="text2"> 注：请上传pdf格式的文件</span>
            </a-upload>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f; opacity: 0">*</span>品牌熟知率
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              v-model="info.brandExposureRate"
              precision="0"
              :disabled="isEdit"
              class="percentage-text"
            />
            <span class="percentage-sign">%</span>
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f; opacity: 0">*</span>好评率
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              :disabled="isEdit"
              v-model="info.goodRate"
              precision="0"
              class="percentage-text"
            />
            <span class="percentage-sign">%</span>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f; opacity: 0">*</span>教师参与率
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              :disabled="isEdit"
              v-model="info.teacherParticipationRate"
              precision="0"
              class="percentage-text"
            />
            <span class="percentage-sign">%</span>
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f; opacity: 0">*</span>学生参与率
          </div>
          <div class="pl16 flex align-items-center">
            <a-input-number
              :disabled="isEdit"
              v-model="info.studentParticipationRate"
              min="0"
              precision="0"
              class="percentage-text"
            />
            <span class="percentage-sign">%</span>
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f; opacity: 0">*</span>品牌公众号
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              placeholder="请输入品牌公众号"
              :maxLength="100"
              v-model="info.weChatPublicAccount"
              :disabled="isEdit"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="main-text-style">
            <span style="color: #f6350f; opacity: 0">*</span>宣传地址
          </div>
          <div class="pl16">
            <a-input
              class="input-style-2"
              type="text"
              placeholder="请输入宣传地址"
              :maxLength="100"
              v-model="info.promotionAddress"
              :disabled="isEdit"
            />
          </div>
        </div>
      </div>
      <div class="mt30">
        <div class="form-item-upload" style="width: 100%">
          <div class="main-text-style">
            <span style="color: #f6350f; opacity: 0">*</span>
            活动方案
          </div>
          <div class="pl16">
            <a-upload
              :file-list="activityfileList"
              :disabled="isEdit || activityLoading"
              :remove="(file, fileList) => handleRemoveActivity(file, fileList)"
              :before-upload="
                (file, fileList) => beforeUploadActivity(file, fileList)
              "
              accept=".pdf"
              :style="{ cursor: isEdit ? 'pointer' : '' }"
              @preview="handleActivePreview"
            >
              <a-button
                :disabled="isEdit || activityLoading"
                :loading="activityLoading"
              >
                <a-icon type="upload" /> 上传方案
              </a-button>
              <span class="text2"> 注：请上传pdf格式的文件</span>
            </a-upload>
          </div>
        </div>
      </div>
    </div>
    <div class="preview-pop-box" v-if="showiframe">
      <div class="preview-boxs" style="height: 90%">
        <newpreview
          :previewUrl="previewUrl"
          @closePreview="showiframe = false"
          :dialogTitle="dialogTitle"
        ></newpreview>
      </div>
    </div>
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
import { postAction, putAction, fileUpdate, getAction } from "@/api/index";
import { baseURL } from "@/utils/request.js";
import newpreview from "@/components/common/newpreviews";
export default {
  name: "",
  components: { newpreview },
  props: {
    oldInfos: {
      type: Object,
    },
    isAdd: {
      type: Boolean,
    },
    isRevise: {
      type: Boolean,
    },
  },
  data() {
    return {
      cascaderProps: {
        multiple: true,
        label: "name",
        value: "id",
        children: "children",
      },
      // 用于强制重新渲染级联选择器
      cascaderKey: Date.now(),
      cascaderRef: null,
      isCheck: false,
      checkState: false,
      submitParams: null,
      dialogTitle: "",
      isEdit: false,
      info: {
        id: "",
        applyType: "2",
        name: "",
        applyYear: "",
        belongDepartment: "",
        foundTime: "",
        brandClassify: "0",
        brandLabels: [],
        weChatPublicAccount: "",
        promotionAddress: "",
        brandExposureRate: "",
        goodRate: "",
        teacherParticipationRate: "",
        studentParticipationRate: "",
        declarationName: "",
        declarationPath: "",
        activityPlanName: "",
        activityPlanPath: "",
        keyword: "",
        brandConnotation: "",
        basicMajorCategory: "",
        basicMajorSubclass: "",
        basicMajor: "",
      },
      zh_CN,
      locale,
      yearShowOne: false,
      path: baseURL,
      fileList: [],
      activityfileList: [],
      loading: false,
      tags: [],
      inputVisible: false,
      kcList: [],
      fieldNames: { label: "name", value: "id", children: "children" },
      zydlList: [],
      zyzlList: [],
      zyList: [],
      isShowZy: false,
      ppnhList: [],
      searchText: "",
      searchTimeout: null,
      activityLoading: false,
      isScore: false,
      showiframe: false,
      previewUrl: "",
      isBrandModule: false,
      hasProcessedBrandLabels: false, // 新增：标记是否已处理brandLabels
    };
  },
  computed: {},
  watch: {
    oldInfos: {
      handler(newValue, oldValue) {
        console.log("收到oldInfos变化:", newValue);
        if (newValue != null && newValue !== oldValue) {
          // 使用浅拷贝避免直接引用
          const newInfo = { ...this.info, ...newValue };

          // 处理brandLabels - 现在放到mounted中异步处理
          // 先存储原始值
          if (newValue.brandLabels) {
            try {
              if (typeof newValue.brandLabels === "string") {
                newInfo.brandLabels = JSON.parse(newValue.brandLabels);
              } else {
                newInfo.brandLabels = newValue.brandLabels;
              }
              console.log("存储原始brandLabels:", newInfo.brandLabels);
            } catch (e) {
              console.error("解析brandLabels失败:", e);
              newInfo.brandLabels = [];
            }
          } else {
            newInfo.brandLabels = [];
          }

          // 品牌内涵初始化
          if (newValue.brandConnotation) {
            newInfo.keyword = Array.isArray(newValue.brandConnotation)
              ? newValue.brandConnotation
              : newValue.brandConnotation.split(",");
          } else {
            newInfo.keyword = [];
          }

          // 转换数字字段
          const numberFields = [
            "brandExposureRate",
            "goodRate",
            "teacherParticipationRate",
            "studentParticipationRate",
          ];
          numberFields.forEach((field) => {
            if (newValue[field] !== undefined && newValue[field] !== null) {
              newInfo[field] = Number(newValue[field]) || 0;
            }
          });

          // 更新info对象
          this.info = newInfo;
          this.normalizeApplyYear();

          // 处理文件列表
          if (
            newValue.declarationName &&
            newValue.declarationName !== "" &&
            newValue.declarationPath &&
            newValue.declarationPath !== ""
          ) {
            this.fileList = [
              {
                path: newValue.declarationPath,
                name: newValue.declarationName,
                uid: 1,
              },
            ];
          } else {
            this.fileList = [];
          }

          // 处理活动方案文件
          if (
            newValue.activityPlanName &&
            newValue.activityPlanName !== "" &&
            newValue.activityPlanPath &&
            newValue.activityPlanPath !== ""
          ) {
            this.activityfileList = [
              {
                path: newValue.activityPlanPath,
                name: newValue.activityPlanName,
                uid: 1,
              },
            ];
          } else {
            this.activityfileList = [];
          }

          // 专业文化品牌显示控制
          if (newValue.brandClassify == "1") {
            this.isShowZy = true;
          } else {
            this.isShowZy = false;
          }

          // 专业信息处理
          if (
            newValue.basicMajorCategory &&
            newValue.basicMajorCategory !== "" &&
            newValue.basicMajorCategory !== "null"
          ) {
            this.zyzl(newValue.basicMajorCategory);
          }

          if (
            newValue.basicMajorSubclass &&
            newValue.basicMajorSubclass !== "" &&
            newValue.basicMajorSubclass !== "null"
          ) {
            this.zylist(newValue.basicMajorSubclass);
          }

          // 标记需要处理brandLabels
          this.hasProcessedBrandLabels = false;
        }
      },
      deep: true,
      immediate: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        this.isEdit = newValue;
        console.log(this.isEdit, "isRevise");

        if (this.$store.state.role == "teacher-role" && this.isBrandModule) {
          this.isEdit = false;
        }
      },
      immediate: true,
    },
  },
  created() {
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    console.log(this.isEdit, 222222222222);
    this.isScore =
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role" ||
      this.$store.state.role === "education-guide-role";
  },
  destroyed() {
    sessionStorage.setItem(
      `step${this.$store.state.user.id}`,
      JSON.stringify(this.info)
    );
  },
  async mounted() {
    console.log("组件mounted，开始初始化");

    const brandModules = this.$store.state.user.brandModules || "";
    this.isBrandModule = brandModules.includes("品牌基本信息");

    this.$nextTick(() => {
      this.cascaderRef = this.$refs.cascaderRef;
    });

    // 并行加载数据
    console.log("开始加载数据...");
    await Promise.all([this.zydl(), this.getkclist(), this.getPpnhlist()]);

    console.log("数据加载完成，kcList:", this.kcList);
    console.log("需要回显的brandLabels:", this.info.brandLabels);

    // 如果有初始数据且尚未处理，处理brandLabels
    if (
      this.info.brandLabels &&
      this.info.brandLabels.length > 0 &&
      !this.hasProcessedBrandLabels
    ) {
      console.log("开始处理brandLabels回显");
      await this.processBrandLabelsForDisplay(this.info.brandLabels);
      this.hasProcessedBrandLabels = true;
    }

    this.$forceUpdate();
  },
  methods: {
    // 处理品牌标签的显示
    async processBrandLabelsForDisplay(labelsArray) {
      console.log("处理品牌标签显示，原始数据:", labelsArray);
      console.log("当前kcList:", this.kcList);

      if (!Array.isArray(labelsArray) || labelsArray.length === 0) {
        console.log("labelsArray为空或不是数组");
        this.info.brandLabels = [];
        return;
      }

      if (this.kcList.length === 0) {
        console.log("kcList尚未加载，等待加载");
        // 等待kcList加载
        setTimeout(() => {
          if (this.kcList.length > 0) {
            this.processBrandLabelsForDisplay(labelsArray);
          }
        }, 500);
        return;
      }

      // 转换字符串数组为级联选择器格式
      const converted =
        this.convertStringArrayToCascaderFormatForDisplay(labelsArray);
      console.log("转换后的级联数据:", converted);

      // 更新数据
      this.info.brandLabels = converted;

      // 强制重新渲染
      this.$nextTick(() => {
        this.forceCascaderRerender();
      });
    },

    // 专用于显示的转换方法
    convertStringArrayToCascaderFormatForDisplay(stringArray) {
      if (!Array.isArray(stringArray) || stringArray.length === 0) {
        return [];
      }

      const result = [];

      // 预构建名称到ID的映射
      const nameToIdMap = this.buildNameToIdMap(this.kcList);
      console.log("名称到ID映射:", nameToIdMap);

      stringArray.forEach((itemName) => {
        console.log(`处理项目: ${itemName}`);

        // 查找这个名称对应的ID
        const itemId = nameToIdMap[itemName];

        if (itemId) {
          console.log(`找到ID: ${itemId} 对应名称: ${itemName}`);

          // 查找这个ID的完整路径
          const path = this.findPathById(itemId, this.kcList);
          console.log(`找到路径:`, path);

          if (path && path.length > 0) {
            // 检查是否需要子节点
            const itemNode = this.findNodeById(itemId, this.kcList);
            console.log(`找到节点:`, itemNode);

            if (itemNode && itemNode.children && itemNode.children.length > 0) {
              // 如果有子节点，添加第一个子节点
              const childId = itemNode.children[0].id;
              const fullPath = [...path, childId];
              console.log(`添加子节点后的完整路径:`, fullPath);
              result.push(fullPath);
            } else {
              // 没有子节点，直接使用路径
              console.log(`无子节点，使用路径:`, path);
              result.push(path);
            }
          } else {
            console.log(`未找到路径，使用ID: [${itemId}]`);
            result.push([itemId]);
          }
        } else {
          console.log(`未找到ID，使用名称作为ID: [${itemName}]`);
          result.push([itemName]);
        }
      });

      console.log("最终转换结果:", result);
      return result;
    },

    // 构建名称到ID的映射
    buildNameToIdMap(options, map = {}) {
      options.forEach((option) => {
        if (option.name) {
          map[option.name] = option.id;
        }
        if (option.children && option.children.length > 0) {
          this.buildNameToIdMap(option.children, map);
        }
      });
      return map;
    },

    // 通过ID查找节点
    findNodeById(id, options) {
      for (const option of options) {
        if (option.id === id) {
          return option;
        }
        if (option.children && option.children.length > 0) {
          const found = this.findNodeById(id, option.children);
          if (found) return found;
        }
      }
      return null;
    },

    // 通过ID查找路径
    findPathById(id, options, currentPath = []) {
      for (const option of options) {
        if (option.id === id) {
          return [...currentPath, option.id];
        }
        if (option.children && option.children.length > 0) {
          const foundPath = this.findPathById(id, option.children, [
            ...currentPath,
            option.id,
          ]);
          if (foundPath) return foundPath;
        }
      }
      return null;
    },

    // 将字符串数组转换为级联选择器需要的二维数组格式（用于新添加）
    convertStringArrayToCascaderFormat(stringArray) {
      if (!Array.isArray(stringArray) || stringArray.length === 0) {
        return [];
      }

      const result = [];
      const processedNames = new Set();

      stringArray.forEach((itemName) => {
        if (processedNames.has(itemName)) {
          return;
        }
        processedNames.add(itemName);

        // 在整个树中查找这个名称
        const path = this.findItemPathInTree(itemName, this.kcList);
        if (path && path.length > 0) {
          console.log(`找到匹配项 ${itemName} 的路径:`, path);
          result.push(path);
        } else {
          console.log(`未找到匹配项: ${itemName}，将作为动态选项处理`);
          // 创建动态选项路径
          const dynamicPath = [itemName];
          result.push(dynamicPath);

          // 添加到kcList
          if (
            !this.kcList.some(
              (item) => item.id === itemName || item.name === itemName
            )
          ) {
            this.kcList.unshift({
              id: itemName,
              name: itemName,
              parentId: "0",
              children: [],
              sort: 0,
            });
          }
        }
      });

      console.log("转换后的结果:", result);
      return result;
    },

    // 在树形结构中查找项的完整路径（修复版本）
    findItemPathInTree(itemName, options, currentPath = []) {
      for (const option of options) {
        if (option.name === itemName) {
          // 找到匹配项，构建路径
          const path = [option.id];

          // 需要检查是否有子节点，如果有，将子节点ID也加入路径
          if (option.children && option.children.length > 0) {
            // 对于有子节点的项，通常需要选择一个子节点
            // 这里可以选择第一个子节点，或者根据实际情况调整
            if (option.children[0] && option.children[0].id) {
              path.push(option.children[0].id);
            }
          }
          return path;
        }

        if (option.children && option.children.length > 0) {
          const foundPath = this.findItemPathInTree(itemName, option.children, [
            ...currentPath,
            option.id,
          ]);
          if (foundPath) {
            // 如果找到了，添加当前节点ID到路径开头
            return [option.id, ...foundPath];
          }
        }
      }
      return null;
    },

    // 处理回车键
    handleEnterKey(e) {
      if (e.target.tagName === "INPUT" && e.key === "Enter") {
        e.preventDefault();
        const searchValue = e.target.value.trim();
        if (searchValue) {
          this.addDynamicOption(searchValue);
          setTimeout(() => {
            e.target.value = "";
          }, 0);
        }
      }
    },

    // 添加动态选项
    async addDynamicOption(searchValue) {
      if (!searchValue) return;

      const exists = this.kcList.some(
        (option) =>
          option.id === searchValue ||
          (option.name &&
            option.name.toLowerCase() === searchValue.toLowerCase())
      );

      if (!exists) {
        const newOption = {
          id: searchValue,
          name: searchValue,
          parentId: "0",
          children: [
            {
              id: `son-${searchValue}`,
              parentId: searchValue,
              sort: 2,
              name: searchValue,
            },
          ],
          sort: 0,
        };

        this.kcList = [newOption, ...this.kcList];

        // 确保brandLabels是数组
        if (!Array.isArray(this.info.brandLabels)) {
          try {
            this.info.brandLabels = JSON.parse(this.info.brandLabels || "[]");
          } catch (e) {
            console.error("解析brandLabels失败:", e);
            this.info.brandLabels = [];
          }
        }

        // 检查是否已经包含这个值
        const valueAlreadyExists = this.info.brandLabels.some(
          (item) =>
            Array.isArray(item) && item.length > 0 && item[0] === searchValue
        );

        if (!valueAlreadyExists) {
          const newValue = [searchValue, `son-${searchValue}`];
          this.info.brandLabels = [...this.info.brandLabels, newValue];

          this.forceCascaderRerender();

          await this.$nextTick();
          this.onChange(this.info.brandLabels);
        }

        this.$message.success(`已添加选项: ${searchValue}`);
      } else {
        this.$message.warning("该选项已存在");
      }
    },

    onChange(value) {
      console.log("级联选择器值变化:", value);
      this.info.brandLabels = value;
      this.$forceUpdate();
    },

    // 获取品牌文化列表
    getkclist() {
      return new Promise((resolve) => {
        getAction("/lxbase/lxBrandLabel/treeList", {}).then((res) => {
          if (res.code === 200) {
            let data = res.result || [];
            console.log("获取到品牌文化列表:", data);
            this.kcList = data;

            // 如果有待处理的brandLabels，现在处理
            if (
              this.info.brandLabels &&
              this.info.brandLabels.length > 0 &&
              !this.hasProcessedBrandLabels
            ) {
              console.log("kcList加载完成，开始处理brandLabels");
              this.processBrandLabelsForDisplay(this.info.brandLabels);
              this.hasProcessedBrandLabels = true;
            }

            resolve(data);
          }
        });
      });
    },

    // 强制级联选择器重新渲染
    forceCascaderRerender() {
      this.cascaderKey = Date.now();
      console.log("强制级联选择器重新渲染");
    },

    // 获取品牌内涵
    getPpnhlist() {
      getAction("/baseCommon/getDictItemsByCode?code=brand_connotation").then(
        (res) => {
          if (res.code == 200) {
            this.ppnhList = res.result;
          }
        }
      );
    },

    // 品牌内涵改变
    handleChangeKeyword(newTags) {
      const newItems = newTags
        .filter((tag) => !this.ppnhList.some((opt) => opt.value === tag))
        .map((tag) => ({ title: tag, value: tag }));

      this.ppnhList = [...this.ppnhList, ...newItems];
      this.info.keyword = newTags;
    },

    // 获取专业大类
    zydl() {
      getAction("/infrastructure/basicMajorCategory/allList", {}).then(
        (res) => {
          if (res.code === 200) {
            let data = res.result;
            if (data) {
              this.zydlList = data;
            }
          }
        }
      );
    },

    handleChange(value) {
      this.zyzl(value);
      this.info.basicMajorSubclass = "";
      this.info.basicMajor = "";
      this.zyList = [];
    },
    handleChange1(value) {
      this.zylist(value);
      this.info.basicMajor = "";
    },

    zyzl(id) {
      getAction("/infrastructure/basicMajorSubclass/queryByCategoryId", {
        gategoryId: id,
      }).then((res) => {
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyzlList = data;
          }
        }
      });
    },

    zylist(id) {
      getAction("/infrastructure/basicMajor/queryBySubclassId", {
        subclassId: id,
      }).then((res) => {
        if (res.code === 200) {
          let data = res.result;
          if (data) {
            this.zyList = data;
          }
        }
      });
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },

    handleChangebrandClassify(e) {
      const value = e.target.value;
      if (value == 0) {
        this.isShowZy = false;
        return;
      }
      if (value == 1) {
        this.isShowZy = true;
      }
    },

    toYearMoment(value) {
      if (value === null || value === undefined || value === "") return "";
      if (moment.isMoment(value)) {
        return value.isValid() ? value : "";
      }
      const s = String(value).trim();
      if (/^\d{4}$/.test(s)) {
        return moment(s, "YYYY");
      }
      const m = moment(value);
      return m.isValid() ? moment(String(m.year()), "YYYY") : "";
    },
    normalizeApplyYear() {
      if (!this.info) return;
      this.info.applyYear = this.toYearMoment(this.info.applyYear);
    },
    openChangeOne(status) {
      if (status) {
        this.normalizeApplyYear();
        this.$nextTick(() => {
          this.yearShowOne = true;
        });
      }
    },

    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },

    beforeUpload(file, fileList) {
      this.handleUpload(file);
      return false;
    },

    handleUpload(file) {
      if (this.fileList.length >= 1) {
        this.$message.error("申报书只能上传一个文件,请移除后再上传");
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.fileList.push(fileItem);
          this.loading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },

    handlePreview(file) {
      if (this.isEdit) {
        if (file.path != "" && file.path != null) {
          this.showiframe = true;
          this.previewUrl = this.oldInfos.declarationPath;
          this.dialogTitle = "申报书预览";
        }
      }
    },

    // 上传活动方案
    handleRemoveActivity(file, fileList) {
      this.activityfileList = this.activityfileList.filter((item) => {
        if (item.path.indexOf(file.name1) === -1) {
          return item;
        }
      });
      const index = this.activityfileList.indexOf(file);
      const newFileList = this.activityfileList.slice();
      newFileList.splice(index, 1);
      this.activityfileList = newFileList;
    },

    beforeUploadActivity(file, fileList) {
      this.handleUploadActivity(file);
      return false;
    },

    handleUploadActivity(file) {
      if (this.activityfileList.length >= 1) {
        this.$message.error("活动方案只能上传一个文件,请移除后再上传");
        return;
      }
      this.activityLoading = true;
      const formData = new FormData();
      formData.append("file", file);
      formData.append("biz", "linxuan");
      fileUpdate(formData).then((res) => {
        if (res.code === 0) {
          this.$message.success(`上传成功`);
          let fileItem = {};
          fileItem.path = res.message;
          fileItem.name = file.name;
          fileItem.uid = file.uid;
          this.activityfileList.push(fileItem);
          this.activityLoading = false;
        } else {
          this.$message.error("上传失败");
        }
      });
    },

    handleActivePreview(file) {
      if (this.isEdit) {
        if (file.path != "" && file.path != null) {
          this.showiframe = true;
          this.previewUrl = this.oldInfos.activityPlanPath;
          this.dialogTitle = "活动方案";
        }
      }
    },

    // 得到年份选择器的值
    panelChangeOne(value) {
      if (!value) {
        this.info.applyYear = "";
      } else if (moment.isMoment(value)) {
        this.info.applyYear = String(value.year());
      } else {
        const m = moment(value);
        this.info.applyYear = m.isValid() ? String(m.year()) : "";
      }
      this.yearShowOne = false;
    },

    goStep() {
      if (this.info && this.info.name === "") {
        if (this.info.name === "" || this.info.name == undefined) {
          this.$message.info("请填写品牌名称");
          return false;
        }
      }
      if (
        (this.info && this.info.applyYear === "") ||
        this.info.applyYear == undefined
      ) {
        this.$message.info("请选择申报年份");
        return false;
      }
      if (this.info && this.info.belongDepartment === "") {
        if (
          this.info.belongDepartment === "" ||
          this.info.belongDepartment == undefined
        ) {
          this.$message.info("请填写所属部门");
          return false;
        }
      }
      if (this.info && this.info.foundTime === "") {
        if (this.info.foundTime === "" || this.info.foundTime == undefined) {
          this.$message.info("请选择建设日期");
          return false;
        }
      }
      if (this.info && this.info.brandClassify === "") {
        if (
          this.info.brandClassify === "" ||
          this.info.brandClassify == undefined
        ) {
          this.$message.info("请选择品牌层级");
          return false;
        }
      }
      if (!this.info.brandLabels) {
        this.$message.info("请选择品牌文化");
        return false;
      }
      if (
        this.info &&
        this.info.brandLabels &&
        this.info.brandLabels.length == "0"
      ) {
        if (
          this.info.brandLabels.length == "0" ||
          this.info.brandLabels == undefined
        ) {
          this.$message.info("请选择品牌文化");
          return false;
        }
      }
      if (this.fileList.length == 0) {
        this.$message.info("请上传申报书");
        return false;
      }
      if (this.info.keyword.length == "0") {
        this.$message.info("请输入品牌内涵关键词");
        return false;
      }

      const dateObj = new Date(this.info.foundTime);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const date = dateObj.getDate();
      const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${date
        .toString()
        .padStart(2, "0")}`;
      let brandLabels = this.info.brandLabels || [];
      this.info.brandConnotation = this.info.keyword.join(",");
      let params = {
        ...this.info,
        foundTime: formattedDate,
        brandLabels: JSON.stringify(brandLabels),
        applyYear: new Date(this.info.applyYear).getFullYear() + "",
        declarationName: this.fileList[0].name,
        declarationPath: this.fileList[0].path,
        brandConnotation: this.info.brandConnotation,
      };
      if (this.activityfileList && this.activityfileList.length != 0) {
        this.info.activityPlanName = this.activityfileList[0].name;
        this.info.activityPlanPath = this.activityfileList[0].path;
        params.activityPlanName = this.activityfileList[0].name;
        params.activityPlanPath = this.activityfileList[0].path;
      }
      this.info.declarationName = this.fileList[0].name;
      this.info.declarationPath = this.fileList[0].path;
      this.submitParams = { ...params };

      this.save(params);
    },

    handleCheck() {
      const checkParams = { ...this.submitParams, checkState: this.checkState };
      this.save(checkParams);
    },

    handleCancelCheck() {
      this.isCheck = false;
    },

    save(params) {
      if (
        this.$parent.editInfo?.auditState == "2" &&
        this.$parent.editInfo?.nowContent
      ) {
        let params1 = {
          id: JSON.parse(this.$parent.editInfo?.nowContent).taskId,
          applicationData: JSON.stringify(this.$nullToEmpty(params)),
        };
        putAction("/audit/lxAuditTask/editTaskAndDetail", params1).then(
          (res) => {
            if (res.code == 200) {
              this.$message.success("保存成功");
              this.$emit("goStep", this.info);
              this.handleCancelCheck();
            } else {
              this.$message.error(res.message);
            }
          }
        );
      } else {
        postAction("/lx/lxApply/yrAdd", params).then((res) => {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.info.id = res.result.id;
            window.sessionStorage.setItem(
              `step${this.$store.state.user.id}`,
              this.info.id
            );
            this.$emit("goStep", this.info);
            this.handleCancelCheck();
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },

    onClean() {
      this.isEdit = false;
    },
  },
};
</script>

<style scoped lang="scss">
.card-item {
  background: #ffffff;
  box-shadow: 1px 2px 14px 7px rgba(180, 180, 180, 0.11);
  padding: 37px 20px;
  box-sizing: border-box;
  margin-bottom: 24px;
  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    border-bottom: 1px solid #d9d9d9;
    .title-text {
      color: #2155b5;
      font-size: 20px;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      border-bottom: 3px solid #2155b5;
      padding: 0px 4px;
    }
    .btn-action {
      width: 100px;
      height: 30px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      margin-right: 10px;
      text-align: center;
    }
  }
  .percentage-sign {
    margin-left: 12px;
  }
}
.mt30 {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .form-item {
    display: flex;
    align-items: center;
    width: 50%;
    .main-text-style {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 0px;
      width: 165px;
      flex-shrink: 0;
       text-align: right;
         padding-right: 10px;
         box-sizing: border-box;
    }
    .form-item-right {
      width: 100%;
    }
  }
  .form-item-upload {
    display: flex;
    align-items: center;
    .main-text-style {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-bottom: 0px;
      width: 165px;
      flex-shrink: 0;
       text-align: right;
         padding-right: 10px;
         box-sizing: border-box;
    }
    .form-item-right {
      width: 240px;
    }
  }
  .keywordBox {
    background: #f3f7fb;
    padding: 12px;
    margin-top: 6px;
    ::v-deep .a-tag {
      margin-right: 20px;
    }
  }
  .pl16 {
    width: calc(100%- 235px);
  }
  .form-item-right {
    width: 100%;
  }
}
.submit-btn-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-group {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 240px;
    margin-top: 50px;
    .btn-action {
      width: 116px;
      height: 40px;
      border-radius: 6px;
      font-weight: 400;
      cursor: pointer;
      line-height: 30px;
      line-height: 38px;
      text-align: center;
    }
  }
}

.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
/deep/ .ant-calendar-picker {
  width: 50%;
}
/deep/ .ant-input {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.plflex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.mb15 {
  margin: 20px;
  width: 165px;
}
.mb15-item {
  border-bottom: 1px solid #e4e0e0;
  padding-bottom: 30px;
  margin-bottom: 30px;
}

.img-box {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 14px 0 15px 10px;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.file-input-box {
  color: #2155b5;
}
.file {
  position: relative;
  width: 156px;
  height: 40px;
  background: #fff;
  border: 1px solid #2155b5;
  border-radius: 4px;
  padding: 4px 12px;
  overflow: hidden;
  color: #575757;
  text-decoration: none;
  text-indent: 0;
  line-height: 20px;
  margin-bottom: 15px;
}
.file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
}
.file:hover {
  background: rgba(218, 218, 218, 0.2);
  color: #000;
  text-decoration: none;
}
.percentage-text {
  width: 85%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.keywordSelect {
  /deep/ .ant-select-selection--multiple {
    min-height: 54px;
    height: auto !important;
    padding: 4px 11px;
    font-size: 18px !important;
    border: 1px solid #d9d9d9;
    color: #999999;
    overflow: hidden;
  }
  /deep/ .ant-select-selection__rendered {
    margin-left: 0 !important;
    margin-bottom: 0 !important;
    height: auto !important;
    min-height: 44px;
    padding: 0 !important;
    line-height: normal !important;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  /deep/ .ant-select-selection__placeholder {
    font-size: 18px !important;
    color: #999999;
    margin-left: 0 !important;
    padding: 0 !important;
    top: 50% !important;
    margin-top: 0 !important;
    transform: translateY(-50%) !important;
    line-height: 1.2;
    right: 24px;
    overflow: visible;
    white-space: nowrap;
    text-overflow: clip;
  }
  /deep/ .ant-select-selection__choice {
    float: none !important;
    font-size: 16px;
    max-width: 100%;
    height: auto !important;
    min-height: 28px;
    line-height: 22px !important;
    margin: 4px 4px 4px 0;
    padding: 3px 24px 3px 8px;
    box-sizing: border-box;
    overflow: hidden;
  }
  /deep/ .ant-select-selection__choice__content {
    display: block;
    max-width: 100%;
    white-space: normal;
    word-break: break-word;
    line-height: 22px;
    overflow: visible;
    text-overflow: clip;
  }
  /deep/ .ant-select-selection__choice__remove {
    top: 50%;
    transform: translateY(-50%);
  }
}
.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }
  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }
  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
/deep/ .ant-select-selection--single {
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
/deep/ .ant-select-selection--single .ant-select-selection__rendered {
  margin-left: 11px;
  line-height: 52px;
  font-size: 18px;
}
/deep/ .ant-select-selection__placeholder {
  font-size: 18px !important;
  color: #999999;
  line-height: 52px;
  margin-left: 0 !important;
  padding: 0 !important;
  top: 0 !important;
  margin-top: 0 !important;
  transform: none !important;
}
/deep/ .el-cascader {
  width: 100%;
  line-height: normal;
}
/deep/ .el-cascader .el-input__inner {
  min-height: 54px !important;
  line-height: 34px !important;
  font-size: 18px !important;
  padding: 4px 30px 4px 11px;
  color: #999999;
}
/deep/ .el-cascader .el-input__suffix {
  display: flex;
  align-items: center;
}
/deep/ .el-cascader__search-input {
  font-size: 18px !important;
  color: #999999;
  height: 32px;
  margin: 2px 0;
}
/deep/ .el-cascader .el-cascader__tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  max-width: calc(100% - 40px);
  left: 11px;
  right: 30px;
  top: 4px;
  transform: none;
}
/deep/ .el-cascader .el-cascader__tags .el-tag {
  max-width: 100%;
  height: auto;
  white-space: normal;
  line-height: 20px;
  padding: 4px 8px;
  margin: 2px 0 2px 6px;
}
</style>